<div
  class="container-xm vh-100"
  [ngClass]="{
    'container-xm': currentPath !== 'finishLine',
    'container-fluid': currentPath === 'finishLine'
  }"
>
  <div class="row">
    <router-outlet></router-outlet>
  </div>
</div>

@if(loadingService.loadingStatus){
<div class="loading">
  <mat-spinner></mat-spinner>
</div>
}
